/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GeneratePlayoffsResponseQualifiedTeamsInner
 */
export interface GeneratePlayoffsResponseQualifiedTeamsInner {
    /**
     * 
     * @type {number}
     * @memberof GeneratePlayoffsResponseQualifiedTeamsInner
     */
    position?: number;
    /**
     * 
     * @type {string}
     * @memberof GeneratePlayoffsResponseQualifiedTeamsInner
     */
    teamId?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneratePlayoffsResponseQualifiedTeamsInner
     */
    teamName?: string;
}

/**
 * Check if a given object implements the GeneratePlayoffsResponseQualifiedTeamsInner interface.
 */
export function instanceOfGeneratePlayoffsResponseQualifiedTeamsInner(value: object): value is GeneratePlayoffsResponseQualifiedTeamsInner {
    return true;
}

export function GeneratePlayoffsResponseQualifiedTeamsInnerFromJSON(json: any): GeneratePlayoffsResponseQualifiedTeamsInner {
    return GeneratePlayoffsResponseQualifiedTeamsInnerFromJSONTyped(json, false);
}

export function GeneratePlayoffsResponseQualifiedTeamsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeneratePlayoffsResponseQualifiedTeamsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'position': json['position'] == null ? undefined : json['position'],
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
        'teamName': json['teamName'] == null ? undefined : json['teamName'],
    };
}

export function GeneratePlayoffsResponseQualifiedTeamsInnerToJSON(json: any): GeneratePlayoffsResponseQualifiedTeamsInner {
    return GeneratePlayoffsResponseQualifiedTeamsInnerToJSONTyped(json, false);
}

export function GeneratePlayoffsResponseQualifiedTeamsInnerToJSONTyped(value?: GeneratePlayoffsResponseQualifiedTeamsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'position': value['position'],
        'teamId': value['teamId'],
        'teamName': value['teamName'],
    };
}

